import React from "react";
import styled from "styled-components";

import { VSpace } from "@examspark/common-ui";

import {
  AlignmentViewCellData,
  AlignmentViewCellVisibility,
} from "./AlignmentViewData";

interface StyledProps {
  isEmpty?: boolean;
  isMuted?: boolean;
}

const Styled = styled.td<StyledProps>`
  ${(props) => props.isEmpty && "background-color: #f7f7f7;"}
`;
const StyledContents = styled.div<StyledProps>`
  ${(props) => props.isMuted && "opacity: 0.3;"}
`;

type Props = {
  data: AlignmentViewCellData;
  visibility: AlignmentViewCellVisibility;
};

const AlignmentViewCell = ({ data, visibility }: Props) => {
  const { isEmpty, isMuted, isSelected, isVisible } = visibility;

  if (!isSelected || !isVisible) return null;

  return (
    <Styled isEmpty={isEmpty}>
      <StyledContents isMuted={isMuted}>
        <VSpace size="0.5rem">{data.contents}</VSpace>
      </StyledContents>
    </Styled>
  );
};

export default AlignmentViewCell;
